import { GenericServiceBase } from "../generic-service";
import { NotificationType } from "./notificacoes.types";

export type AppNotification = {
  id: string;
  tipo: NotificationType;
  titulo: string;
  mensagem: string;
  lida: boolean;
  referenceId: string | null;
  criadaEm: string;
  atendimentoFinalizado?: boolean;
};

export class NotificacoesService extends GenericServiceBase {
  constructor() {
    super("");
  }

  async listar(idConta: string): Promise<AppNotification[]> {
    return (await this.f.get(
      `/contas/${idConta}/notificacoes`,
    )) as AppNotification[];
  }

  async marcarComoLida(idConta: string, id: string): Promise<void> {
    await this.f.patch(`/contas/${idConta}/notificacoes/${id}/lida`);
  }

  async marcarTodasComoLidas(idConta: string): Promise<void> {
    await this.f.patch(`/contas/${idConta}/notificacoes/lidas`);
  }
}
